export default {
  QuickSearch: {
    Title: 'Tìm nhân viên',
  },
  List: {
    Title: 'Danh sách vật tư hàng hóa',
    AddBtn: 'Thêm',
    SearchEmptyText: 'Tìm kiếm',
    ActionColumn: 'Chức năng',
  },
  detail: {
    asset_code: 'Mã tài sản',
  },
};
